import React, { useState, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Car from "@material-ui/icons/DirectionsCar";
import Vehicles from "./Vehicles";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
import Button from "components/CustomButtons/CustomButton";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Tasks from "components/Tasks/Tasks.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardText from "components/Card/CardText.js";
import CardBody from "components/Card/CardBody.js";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select, { SelectChangeEvent } from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import jwt_decode from "jwt-decode";
import Snackbar from "components/Snackbar/Snackbar.js";
import { useTranslation } from "react-i18next";
import CreateIcon from "@material-ui/icons/Create";

import { widgetStories, bugs, website, server } from "variables/general.js";

import image from "assets/img/faces/card-profile1-square.jpg";

import { validateField, isAgent } from "components/Utils/utils";

import {
  cardTitle,
  roseColor,
} from "assets/jss/material-dashboard-pro-react.js";
import { getCustomerByToken } from "views/Services/OrdersService";
import {
  getAgentProfile,
  updateAgentProfile,
} from "views/Services/AgencyService";
import {
  saveCustomerSettingsAPI,
  saveUserSettingsAPI,
  getZipCodeData,
} from "views/Services/ClientService";

const styles = {
  cardTitle,
  cardTitleWhite: {
    ...cardTitle,
    color: "#FFFFFF",
    marginTop: "0",
  },
  cardCategoryWhite: {
    margin: "0",
    color: "rgba(255, 255, 255, 0.8)",
    fontSize: ".875rem",
  },
  cardCategory: {
    color: "#999999",
    marginTop: "10px",
  },
  icon: {
    color: "#333333",
    margin: "10px auto 0",
    width: "130px",
    height: "130px",
    border: "1px solid #E5E5E5",
    borderRadius: "50%",
    lineHeight: "174px",
    "& svg": {
      width: "55px",
      height: "55px",
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      width: "55px",
      fontSize: "55px",
    },
  },
  iconRose: {
    color: roseColor,
  },
  marginTop30: {
    marginTop: "30px",
  },
  testimonialIcon: {
    marginTop: "30px",
    "& svg": {
      width: "40px",
      height: "40px",
    },
  },
  cardTestimonialDescription: {
    fontStyle: "italic",
    color: "#999999",
  },
};

import extendedFormstyles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import zIndex from "@material-ui/core/styles/zIndex";
import { use } from "react";
import { Grid } from "@material-ui/core";

const useStyles = makeStyles(styles);
const useExtFormStyles = makeStyles(extendedFormstyles);

export default function Widgets() {
  const { t } = useTranslation();
  const [toastMessage, setToastMessage] = useState(false);
  const [messageToast, setMessageToast] = useState("");
  const [typeToast, setTypeToast] = useState("");
  const classesExtForm = useExtFormStyles();
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [statesDl, setStatesDl] = React.useState([]);
  const [states, setStates] = React.useState([]);
  useEffect(() => {
    if (isAgent) {
      getAgent();
    } else {
      getCustomer();
    }
  }, [dispatch]);
  const getCustomer = async () => {
    const resultSubmit = await dispatch(getCustomerByToken({}));
    setData(resultSubmit.payload.data);
    setCustomerData(resultSubmit.payload.data.data_customer);
    setUserData({
      email: resultSubmit.payload.data.data_customer.email,
      password: "",
      confirmPassword: "",
    });
    if (resultSubmit.payload.data?.data_customer?.dl_country_id) {
      setStatesDl(
        resultSubmit.payload.data.catalogs.states.filter(
          (e) =>
            e.country_id ==
            resultSubmit.payload.data.data_customer.dl_country_id
        )
      );
    }
    if (resultSubmit.payload.data?.data_customer?.country_id) {
      setStates(
        resultSubmit.payload.data.catalogs.states.filter(
          (e) =>
            e.country_id == resultSubmit.payload.data.data_customer.country_id
        )
      );
    }
  };
  const getAgent = async () => {
    const resultSubmit = await dispatch(getAgentProfile({}));
    setData(resultSubmit.payload.data);
    setUserData({
      agency_current: resultSubmit.payload.data.Agency.id,
      user_id: resultSubmit.payload.data.User.id,
      lob: resultSubmit.payload.data.Agency.lob_id,
      producerCode: resultSubmit.payload.data.Agency.producer_code,
      producerName: resultSubmit.payload.data.Agency.agency_name,
      agency: resultSubmit.payload.data.Agency.id,
      username: resultSubmit.payload.data.User.username,
      email: resultSubmit.payload.data.User.email,
      fname: resultSubmit.payload.data.Profile.first_name,
      mname: resultSubmit.payload.data.Profile.middle_initial,
      lname: resultSubmit.payload.data.Profile.last_name,
      address: resultSubmit.payload.data.Profile.address,
      city: resultSubmit.payload.data.Profile.city,
      country: resultSubmit.payload.data.Profile.country_id,
      state: resultSubmit.payload.data.Profile.state_id,
      zipcode: resultSubmit.payload.data.Profile.zipcode,
      pobox: resultSubmit.payload.data.Profile.pobox,
      phone: resultSubmit.payload.data.Profile.phone,
      fax: resultSubmit.payload.data.Profile.fax,
      phone_country: resultSubmit.payload.data.Profile.phone_country,
      preferred_language: resultSubmit.payload.data.Profile.preferred_language,
      pass1: "",
      userId: resultSubmit.payload.data.User.id,
    });
    if (resultSubmit.payload.data?.user?.dl_country_id) {
      setStatesDl(
        resultSubmit.payload.data.catalogs.states.filter(
          (e) => e.country_id == resultSubmit.payload.data.user.country_id
        )
      );
    }
    if (resultSubmit.payload.data?.user?.country_id) {
      setStates(
        resultSubmit.payload.data.catalogs.states.filter(
          (e) => e.country_id == resultSubmit.payload.data.user.country_id
        )
      );
    }
  };
  const handleFormChange = (e) => {
    const { name, value } = e.target;

    if (name === "dl_country_id" || name === "dl_country") {
      setStatesDl(data.catalogs.states.filter((e) => e.country_id == value));
    }
    if (name === "country_id" || name === "country") {
      setStates(data.catalogs.states.filter((e) => e.country_id == value));
    }
    localStorage.getItem("userType") === "3"
      ? setCustomerData({ ...customerData, [name]: value })
      : setUserData({ ...userData, [name]: value });
  };

  const handleFormChangeUser = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };
  const classes = useStyles();
  const saveUserSettings = async () => {
    const token = localStorage.getItem("userToken");
    let sended = {};
    if (userData.password === userData.confirmPassword) {
      if (isAgent) {
        sended = { ...userData };
        sended.pass1 = userData.password;
      } else {
        sended = {
          token: token,
          email: userData.email,
          password: userData.password,
        };
      }
      const resultSubmit = await dispatch(
        isAgent
          ? updateAgentProfile(sended)
          : saveUserSettingsAPI(sended)
      );
      if (resultSubmit.payload.result) {
        setToastMessage(true);
        setTypeToast("success");
        setMessageToast("Information updated.");
      } else {
        setToastMessage(true);
        setTypeToast("danger");
        setMessageToast(resultSubmit.payload.message);
      }
    } else {
      setToastMessage(true);
      setTypeToast("danger");
      setMessageToast("Passwords don't match.");
    }
  };
  const saveClientSettings = async () => {
    const token = localStorage.getItem("userToken");
    const sended = customerData;
    let isValidForm = validSendFormProfile();
    sended.token = token;
    if (isValidForm) {
      const resultSubmit = await dispatch(saveCustomerSettingsAPI(sended));
      if (resultSubmit.payload.result) {
        setToastMessage(true);
        setTypeToast("success");
        setMessageToast("Information updated.");
        localStorage.setItem("preferredLanguage", sended.preferred_language);
      } else {
        setToastMessage(true);
        setTypeToast("danger");
        setMessageToast(resultSubmit.payload.message);
      }
    }
  };

  const getCodeData = async (zipCode) => {
    let currentCustomerData = { ...customerData, zipcode: zipCode };
    if (validateField(zipCode)) {
      let dateToSend = { zipCode };
      const resultSubmit = await dispatch(getZipCodeData(dateToSend));
      if (resultSubmit.payload.result) {
        currentCustomerData.city = resultSubmit.payload.data.city_name;
        currentCustomerData.country_id = resultSubmit.payload.data.country_id;
        currentCustomerData.state_id = resultSubmit.payload.data.state_id;
        setStates(
          data.catalogs.states.filter(
            (e) => e.country_id == resultSubmit.payload.data.country_id
          )
        );
      }
      setCustomerData(currentCustomerData);
    } else {
      setCustomerData(currentCustomerData);
    }
  };

  const validSendFormProfile = () => {
    let isValidForm = true;
    if (
      !validateField(customerData.address) ||
      !validateField(customerData.zipcode) ||
      !validateField(customerData.city) ||
      !validateField(customerData.phone) ||
      !validateField(customerData.email)
    ) {
      isValidForm = false;
      let messageError = "<ul>";
      messageError += !validateField(customerData.address)
        ? "<li>The address is required</li>"
        : "";
      messageError += !validateField(customerData.zipcode)
        ? "<li>The zipCode is required</li>"
        : "";
      messageError += !validateField(customerData.city)
        ? "<li>The City is required</li>"
        : "";
      messageError += !validateField(customerData.phone)
        ? "<li>The Phone is required</li>"
        : "";
      messageError += !validateField(customerData.email)
        ? "<li>The Email is required</li>"
        : "";
      messageError += "</ul>";
      setToastMessage(true);
      setTypeToast("danger");
      setMessageToast(messageError);
    }
    return isValidForm;
  };

  const agentProfileEdit = () => {
    return (
      <Card>
        <CardHeader color="warning" text>
          <CardText color="warning">
            <h4 className={classes.cardTitleWhite}>
              {t("profile.userSettings")}
            </h4>
            <h4 className={classes.cardCategoryWhite}>
              {t("profile.systemConfiguration")}
            </h4>
          </CardText>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={12}>
              <CustomInput
                labelText={t("profile.userName")}
                id="username"
                formControlProps={{ fullWidth: true }}
                inputProps={{ value: userData?.username }}
              />
            </GridItem>
            <GridItem xs={12}>
              <CustomInput
                labelText={t("profile.email")}
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  name: "email",
                  value: userData?.email,
                  onChange: handleFormChangeUser,
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                labelText={t("profile.firstName")}
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  name: "fname",
                  value: userData?.fname,
                  onChange: handleFormChangeUser,
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                labelText={t("profile.middleName")}
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  name: "mname",
                  value: userData?.mname,
                  onChange: handleFormChangeUser,
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                labelText={t("profile.lastName")}
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  name: "lname",
                  value: userData?.lname,
                  onChange: handleFormChangeUser,
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText={t("profile.address")}
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  name: "address",
                  value: userData?.address,
                  onChange: handleFormChangeUser,
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText={t("profile.city")}
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  name: "city",
                  value: userData?.city,
                  onChange: handleFormChangeUser,
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomSelect
                labelText={t("step2.country")}
                menuItems={
                  data?.catalogs
                    ? data.catalogs.countries.map((item) => ({
                        value: item.id,
                        label: item.name,
                      }))
                    : []
                }
                formControlProps={{
                  fullWidth: true,
                  className: classes.customFormControlClasses,
                }}
                name="country"
                value={userData?.country}
                onChange={(e) => handleFormChange(e)}
                inputProps={{
                  required: true,
                  name: "country",
                  id: "countryStep2",
                  value: userData?.country,
                  onChange: handleFormChange,
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomSelect
                labelText={t("step2.state")}
                menuItems={
                  data?.catalogs
                    ? data.catalogs.states.map((item) => ({
                        value: item.id,
                        label: item.name,
                      }))
                    : []
                }
                formControlProps={{
                  fullWidth: true,
                  className: classes.customFormControlClasses,
                }}
                name="state"
                value={userData?.state}
                onChange={(e) => handleFormChange(e)}
                inputProps={{
                  required: true,
                  name: "state",
                  id: "stateStep2",
                  value: userData?.state,
                  onChange: handleFormChange,
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText={t("profile.zipCode")}
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  name: "zipcode",
                  value: userData?.zipcode,
                  onChange: handleFormChangeUser,
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText={t("profile.poBox")}
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  name: "pobox",
                  value: userData?.pobox,
                  onChange: handleFormChangeUser,
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText={t("profile.phone")}
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  name: "phone",
                  value: userData?.phone,
                  onChange: handleFormChangeUser,
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText={t("profile.fax")}
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  name: "fax",
                  value: userData?.fax,
                  onChange: handleFormChangeUser,
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomSelect
                labelText={t("profile.phoneCountry")}
                menuItems={
                  data?.catalogs
                    ? data.catalogs.countries.map((item) => ({
                        value: item.id,
                        label: item.name,
                      }))
                    : []
                }
                formControlProps={{
                  fullWidth: true,
                  className: classes.customFormControlClasses,
                }}
                name="phone_country"
                value={userData?.phone_country}
                onChange={(e) => handleFormChange(e)}
                inputProps={{
                  required: true,
                  name: "phone_country",
                  id: "phoneCountryStep2",
                  value: userData?.phone_country,
                  onChange: handleFormChange,
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomSelect
                labelText={t("step2.preferredLanguage")}
                menuItems={[
                  {
                    value: "",
                    label: t("step2.preferredLanguage"),
                  },
                  {
                    value: "en",
                    label: "English",
                  },
                  {
                    value: "es",
                    label: "Español",
                  },
                ]}
                formControlProps={{
                  fullWidth: true,
                  className: classes.customFormControlClasses,
                }}
                name="preferred_language"
                value={userData?.preferred_language}
                onChange={(e) => handleFormChange(e)}
                inputProps={{
                  required: true,
                  name: "preferred_language",
                  id: "preferredLanguageStep2",
                  value: userData?.preferred_language,
                  onChange: handleFormChange,
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12}>
              <CustomInput
                labelText={t("profile.password")}
                name="password"
                type="password"
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  name: "password",
                  type: "password",
                  value: userData?.password,
                  onChange: handleFormChangeUser,
                }}
              />
            </GridItem>
            <GridItem xs={12}>
              <CustomInput
                labelText={t("profile.confirmPassword")}
                name="confirmPassword"
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  name: "confirmPassword",
                  type: "password",
                  value: userData?.confirmPassword,
                  onChange: handleFormChangeUser,
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} style={{ textAlign: "center" }}>
              <Button
                variant="green"
                className={classes.updateProfileButton}
                style={{ marginTop: "20px" }}
                onClick={saveUserSettings}
              >
                {t("profile.saveUserSettings")}
              </Button>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    );
  };

  const agentProfileView = () => {
    return (
      <Card>
        <CardBody>
          <GridContainer>
            <GridItem xs={2}>
              <span style={{ fontWeight: "bold" }}>{t("profile.contact")}</span>
            </GridItem>
            <GridItem xs={10}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <span>{t("profile.name")}</span>
                </GridItem>
                <GridItem xs={12} sm={12} md={8}>
                  <span>{userData?.fname}</span>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={2}>
              <span style={{ fontWeight: "bold" }}></span>
            </GridItem>
            <GridItem xs={10}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <span>{t("profile.userName")}</span>
                </GridItem>
                <GridItem xs={12} sm={12} md={8}>
                  <span>{userData?.username}</span>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={2}>
              <span style={{ fontWeight: "bold" }}></span>
            </GridItem>
            <GridItem xs={10}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <span>{t("profile.email")}</span>
                </GridItem>
                <GridItem xs={12} sm={12} md={8}>
                  <span>{userData?.email}</span>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={2}>
              <span style={{ fontWeight: "bold" }}></span>
            </GridItem>
            <GridItem xs={10}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <span>{t("profile.phone")}</span>
                </GridItem>
                <GridItem xs={12} sm={12} md={8}>
                  <span>{userData?.phone}</span>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={2}>
              <span style={{ fontWeight: "bold" }}></span>
            </GridItem>
            <GridItem xs={10}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <span>{t("profile.fax")}</span>
                </GridItem>
                <GridItem xs={12} sm={12} md={8}>
                  <span>{userData?.fax}</span>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={2}>
              <span style={{ fontWeight: "bold" }}></span>
            </GridItem>
            <GridItem xs={10}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <span>{t("profile.address")}</span>
                </GridItem>
                <GridItem xs={12} sm={12} md={8}>
                  <span>{userData?.address}</span>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={2}>
              <span style={{ fontWeight: "bold" }}>{t("profile.agent")}</span>
            </GridItem>
            <GridItem xs={10}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <span>
                    {userData?.producerCode} - {userData?.producerName}
                  </span>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    );
  };

  const setSnackBar = () => {
    return (
      <GridItem xs={12} sm={12} md={3}>
        <Snackbar
          style={{ position: "absolute", top: "50px" }}
          place="bc"
          color={typeToast}
          message={messageToast}
          open={toastMessage}
          closeNotification={() => setToastMessage(false)}
          close
        />
      </GridItem>
    );
  };

  const ClientData = useMemo(() => {
    return (
      <div>
        {customerData ? (
          <GridItem xs={12}>
            <CustomInput
              labelText={<span>{t("profile.clientNumber")}</span>}
              id="clientnumber"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                disabled: true,
                value: customerData.id,
              }}
            />
            <CustomInput
              labelText={
                <span>
                  {t("profile.driverLicense")} <small></small>
                </span>
              }
              id="driverlicense"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                disabled: true,
                value: customerData.dl_number,
                onChange: (event) => {
                  setLicence(event.target.value);
                },
              }}
            />
            <FormControl
              fullWidth
              className={classesExtForm.selectFormControl}
              style={{ marginTop: "10px" }}
            >
              <InputLabel
                htmlFor="simple-select"
                className={classesExtForm.selectLabel}
              >
                {t("profile.dlCountry")}
              </InputLabel>
              <Select
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                classes={{
                  select: classesExtForm.select,
                }}
                value={customerData.dl_country_id}
                name="dl_country_id"
                onChange={handleFormChange}
                inputProps={{
                  name: "dl_country_id",
                  id: "simple-select",
                }}
              >
                <MenuItem
                  disabled
                  classes={{
                    root: classesExtForm.selectMenuItem,
                  }}
                >
                  {t("profile.country")}
                </MenuItem>
                {data.catalogs.countries.map((item) => (
                  <MenuItem
                    classes={{
                      root: classesExtForm.selectMenuItem,
                      selected: classesExtForm.selectMenuItemSelected,
                    }}
                    value={item.id}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              fullWidth
              className={classesExtForm.selectFormControl}
              style={{ marginTop: "10px" }}
            >
              <InputLabel
                htmlFor="simple-select"
                className={classesExtForm.selectLabel}
              >
                {t("profile.validDL")}
              </InputLabel>
              <Select
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                classes={{
                  select: classesExtForm.select,
                }}
                value={customerData.valid_license}
                onChange={handleFormChange}
                inputProps={{
                  name: "valid_license",
                  id: "simple-select",
                }}
              >
                <MenuItem
                  classes={{
                    root: classesExtForm.selectMenuItem,
                    selected: classesExtForm.selectMenuItemSelected,
                  }}
                  value="1"
                >
                  {t("common.yes")}
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classesExtForm.selectMenuItem,
                    selected: classesExtForm.selectMenuItemSelected,
                  }}
                  value="0"
                >
                  {t("common.no")}
                </MenuItem>
              </Select>
            </FormControl>
            <FormControl
              fullWidth
              className={classesExtForm.selectFormControl}
              style={{ marginTop: "10px" }}
            >
              <InputLabel
                htmlFor="simple-select"
                className={classesExtForm.selectLabel}
              >
                {t("profile.dlState")}
              </InputLabel>
              <Select
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                classes={{
                  select: classesExtForm.select,
                }}
                value={customerData.dl_state_id}
                onChange={handleFormChange}
                inputProps={{
                  name: "dl_state_id",
                  id: "simple-select",
                }}
              >
                {statesDl.map((item) => (
                  <MenuItem
                    classes={{
                      root: classesExtForm.selectMenuItem,
                      selected: classesExtForm.selectMenuItemSelected,
                    }}
                    value={item.id}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <CustomInput
              labelText={
                <span>
                  {t("profile.firstName")} <small></small>
                </span>
              }
              id="firstname"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                disabled: true,
                value: customerData.first_name,
                onChange: (event) => {
                  setfirstname(event.target.value);
                },
              }}
            />
            <CustomInput
              labelText={<span> {t("profile.middleName")}</span>}
              id="middlename"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                disabled: true,
                value: customerData.middle_name,
              }}
            />
            <CustomInput
              labelText={
                <span>
                  {t("profile.lastName")} <small></small>
                </span>
              }
              id="lastname"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                disabled: true,
                value: customerData.last_name,
              }}
            />
            <CustomInput
              labelText={
                <span>
                  {t("profile.address")} <small></small>
                </span>
              }
              id="address"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                name: "address",
                value: customerData.address,
                onChange: (event) => {
                  handleFormChange(event);
                },
              }}
            />
            <CustomInput
              labelText={
                <span>
                  {t("profile.zipCode")} <small></small>
                </span>
              }
              id="zipcode"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                name: "zipcode",
                value: customerData.zipcode,
                onChange: (event) => {
                  handleFormChange(event);
                },
                onBlur: (event) => {
                  const { id, value } = event.target;
                  getCodeData(value);
                },
              }}
            />
            <CustomInput
              labelText={
                <span>
                  {t("profile.city")} <small></small>
                </span>
              }
              id="city"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                name: "city",
                value: customerData.city,
                onChange: (event) => {
                  handleFormChange(event);
                },
              }}
            />
            <FormControl
              fullWidth
              className={classesExtForm.selectFormControl}
              style={{ marginTop: "10px" }}
            >
              <InputLabel
                htmlFor="simple-select"
                className={classesExtForm.selectLabel}
              >
                {t("profile.country")}
              </InputLabel>
              <Select
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                classes={{
                  select: classesExtForm.select,
                }}
                value={customerData.country_id}
                name="country_id"
                onChange={handleFormChange}
                inputProps={{
                  name: "country_id",
                  id: "simple-select",
                }}
              >
                <MenuItem
                  disabled
                  classes={{
                    root: classesExtForm.selectMenuItem,
                  }}
                >
                  {t("profile.country")}:
                </MenuItem>
                {data.catalogs.countries.map((item) => (
                  <MenuItem
                    classes={{
                      root: classesExtForm.selectMenuItem,
                      selected: classesExtForm.selectMenuItemSelected,
                    }}
                    value={item.id}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              fullWidth
              className={classesExtForm.selectFormControl}
              style={{ marginTop: "10px" }}
            >
              <InputLabel
                htmlFor="simple-select"
                className={classesExtForm.selectLabel}
              >
                {t("profile.state")}
              </InputLabel>
              <Select
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                classes={{
                  select: classesExtForm.select,
                }}
                value={customerData.state_id}
                onChange={handleFormChange}
                inputProps={{
                  name: "state_id",
                  id: "simple-select",
                }}
              >
                {states.map((item) => (
                  <MenuItem
                    classes={{
                      root: classesExtForm.selectMenuItem,
                      selected: classesExtForm.selectMenuItemSelected,
                    }}
                    value={item.id}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <CustomInput
              labelText={
                <span>
                  {t("profile.phone")} <small></small>
                </span>
              }
              id="phone"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                name: "phone",
                value: customerData.phone,
                onChange: (event) => {
                  handleFormChange(event);
                },
              }}
            />
            <CustomInput
              labelText={
                <span>
                  {t("profile.email")} <small></small>
                </span>
              }
              id="email"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                name: "email",
                value: customerData.email,
                onChange: (event) => {
                  handleFormChange(event);
                },
              }}
            />
            <CustomInput
              labelText={<span>{t("profile.additionalInsured")}</span>}
              id="additionalInsured"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                name: "additional_insured",
                value: customerData.additional_insured,
                onChange: handleFormChange,
              }}
            />
            <FormControl
              fullWidth
              className={classesExtForm.selectFormControl}
              style={{ marginTop: "10px" }}
            >
              <InputLabel
                htmlFor="simple-select"
                className={classesExtForm.selectLabel}
              >
                {t("profile.preferredLanguage")}
              </InputLabel>
              <Select
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                classes={{
                  select: classesExtForm.select,
                }}
                value={customerData.preferred_language}
                name="preferred_language"
                onChange={handleFormChange}
                inputProps={{
                  name: "preferred_language",
                  id: "simple-select",
                }}
              >
                <MenuItem
                  disabled
                  classes={{
                    root: classesExtForm.selectMenuItem,
                  }}
                >
                  {t("profile.preferredLanguage")}
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classesExtForm.selectMenuItem,
                    selected: classesExtForm.selectMenuItemSelected,
                  }}
                  value="en"
                >
                  {`English`}
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classesExtForm.selectMenuItem,
                    selected: classesExtForm.selectMenuItemSelected,
                  }}
                  value="es"
                >
                  {`Spanish`}
                </MenuItem>
              </Select>
            </FormControl>
          </GridItem>
        ) : null}
        <GridContainer>
          <GridItem xs={12} style={{ textAlign: "center" }}>
            <Button
              variant="success"
              className={classes.updateProfileButton}
              style={{ marginTop: "20px" }}
              onClick={() => saveClientSettings()}
            >
              {t("profile.saveClientData")}
            </Button>
          </GridItem>
        </GridContainer>
      </div>
    );
  }, [customerData, handleFormChange]);
  return (
    <div style={{ width: "100%" }}>
      {customerData && userData ? (
        <GridContainer>
          {setSnackBar()}
          <GridItem xs={12} sm={12} md={6}>
            <Card>
              <CardHeader color="warning" text>
                <CardText color="warning">
                  <h4 className={classes.cardTitleWhite}>
                    {t("profile.userSettings")}
                  </h4>
                  <h4 className={classes.cardCategoryWhite}>
                    {t("profile.systemConfiguration")}
                  </h4>
                </CardText>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("profile.clientNumber")}
                      id="clientnumber"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{ disabled: true, value: customerData.id }}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("profile.emailAddress")}
                      email="email-address"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{
                        name: "email",
                        value: userData.email,
                        onChange: handleFormChangeUser,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("profile.password")}
                      name="password"
                      type="password"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{
                        name: "password",
                        type: "password",
                        value: userData.password,
                        onChange: handleFormChangeUser,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("profile.confirmPassword")}
                      name="confirmPassword"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{
                        name: "confirmPassword",
                        type: "password",
                        value: userData.confirmPassword,
                        onChange: handleFormChangeUser,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} style={{ textAlign: "center" }}>
                    <Button
                      variant="success"
                      className={classes.updateProfileButton}
                      style={{ marginTop: "20px" }}
                      onClick={saveUserSettings}
                    >
                      {t("profile.saveUserSettings")}
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <CustomTabs
              headerColor="rose"
              tabs={[
                {
                  tabName: t("profile.clientData"),
                  tabIcon: Person,
                  tabContent: <span>{ClientData}</span>,
                },
                {
                  tabName: t("profile.vehicles"),
                  tabIcon: Car,
                  tabContent: <Vehicles data={data} vehicles={data.vehicles} />,
                },
              ]}
            />
          </GridItem>
        </GridContainer>
      ) : (
        <GridContainer>
          {setSnackBar()}
          <GridItem xs={12} sm={12} md={6}>
            {userData && (
              <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: t("profile.information"),
                    tabIcon: Person,
                    tabContent: agentProfileView(),
                  },
                  {
                    tabName: t("profile.edit"),
                    tabIcon: CreateIcon,
                    tabContent: agentProfileEdit(),
                  },
                ]}
              />
            )}
          </GridItem>
        </GridContainer>
      )}
    </div>
  );
}
